import { useRef } from 'react'

// A separate identity per mounted pane/hook keeps tabs and sibling charts
// independent. Only an effect starting a new load advances the generation.
export function useChartRequestOwner() {
  const owner = useRef(null)
  if (owner.current === null) {
    owner.current = { requestScope: crypto.randomUUID(), requestGeneration: 0 }
  }
  return owner
}
